import setupAxios from '../../lib/redux/setupAxios'

export const get = async (queryParams) => {
    return setupAxios
        .get('/', { params: queryParams })
        .then((res) => res?.data?.data)
}

export const wmrcDivisionGroup = async (payload) => {
    return setupAxios
        .post('/groups/filter', payload)
        .then((res) => res?.data?.data)
}

export const getGroupContacts = async ({id,payload}) => {
    return setupAxios
        .post(`/groups/get_groups_contacts/${id}`,payload)
        .then((res) => res?.data?.data)
}

export const updateGroupContacts = async ({ id, payload }) => {
    return setupAxios.post(`/groups/update_group_contacts/${id}`, payload).then(res => res?.data)
}


export const getUserWithDevice = async ({id,queryParams}) => {
    return setupAxios
        .get(`/groups/get_groups_users_with_device_count/${id}`,{
            params:queryParams
        })
        .then((res) => res?.data?.data)
}


export const fetchReportList = async () => {
    return setupAxios
        .get(`/reports`)
        .then((res) => res?.data?.data)
}

export const fetchIncidentAnalysisData = async (payload) => {
    return setupAxios
        .post(`/reports/report_data`,payload)
        .then((res) => res?.data?.data ?? []);
}
export const fetchIncidentAnalysisDataExcel = async (payload) => {
    return setupAxios
        .post(`/reports/report_data`,payload)
        .then((res) => res?.data ?? []);
}

export const emailReport = async (payload) => {
    return setupAxios
        .post(`/reports/email_report`, payload)
        .then((res) => res?.data);
}
